'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { LinearProgress, Box } from '@mui/material';

/**
 * Route Loading Indicator
 * Shows a loading bar at the top of the page during route transitions
 */
export function RouteLoadingIndicator() {
  const pathname = usePathname();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Show loading indicator
    setLoading(true);

    // Hide loading indicator after a delay
    // This gives time for the new page to start rendering and initial data to load
    const timer = setTimeout(() => {
      setLoading(false);
    }, 800);

    return () => clearTimeout(timer);
  }, [pathname]);

  if (!loading) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
      }}
    >
      <LinearProgress
        sx={{
          height: 3,
          bgcolor: 'action.hover',
          '& .MuiLinearProgress-bar': {
            backgroundColor: 'primary.main',
          },
        }}
      />
    </Box>
  );
}
